import { useState, useRef, forwardRef } from "react";
import "./index.style.css";
import { categoryTreatments } from "../Cart/index";
import { Disclosure } from "@headlessui/react";

const icons: Record<string, JSX.Element> = {
  face: (
    <svg xmlns="http://www.w3.org/2000/svg" height="50" viewBox="0 0 45.6 50" width="45.6"><g fill="#97afbc"><path d="m8.2 16.2c0-8.1 6.6-14.6 14.6-14.6 7.4 0 13.5 5.5 14.5 12.6-2.5 1.9-5.6 3-8.8 3-4.8 0-9.3-2.4-12-6.3l-1.3.9c3 4.4 8 7 13.3 7 3.2 0 6.3-1 9-2.7v.2 14.2h1.5v-14.3c0-8.9-7.3-16.2-16.2-16.2s-16.2 7.3-16.2 16.2v14.2h1.6z"></path><path d="m33.1 39h-.4l-.3.4c-1.9 2.5-5.5 4.1-9.6 4.1-4 0-7.7-1.6-9.6-4.1l-.2-.4h-.4c-.2 0-12.6 1.2-12.6 11h1.6c0-7.6 8.8-9.1 10.7-9.4 2.2 2.7 6.2 4.4 10.6 4.4 4.3 0 8.3-1.7 10.5-4.4 2 .3 10.7 2 10.7 9.4h1.6c-.1-9.8-12.5-11-12.6-11z"></path></g></svg>
  ),
  "body-sevice": (
    <svg xmlns="http://www.w3.org/2000/svg" height="50" viewBox="0 0 46.8 50" width="46.8"><g fill="#97afbc"><path d="m20.7 6-1.3-.9c-1.7 2.5-4.5 4-7.5 4-3.4 0-6.4-1.9-8-4.7v-.1c-.7-1.3-1.1-2.8-1.1-4.3h-1.6c0 1.8.5 3.5 1.3 5.1 1.8 4.3 4.6 8.5 4.7 8.6 3.5 5.9-.8 11.2-2.2 13-.1.1-.2.3-.3.4-.1.2-.3.3-.4.5-1 1.2-2.2 2.8-3.3 6.7-2 7.2-.4 15.4-.3 15.7l1.6-.3c0-.1-1.6-8.2.3-15 1-3.6 2.1-5 3-6.2.1-.2.3-.4.4-.5s.2-.2.3-.3c4.2-5.3 5-10.3 2.3-14.8 0 0-1.1-1.6-2.3-3.8 1.6 1 3.6 1.6 5.7 1.6 3.4 0 6.7-1.8 8.7-4.7z"></path><path d="m45.8 34.2c-1.1-3.9-2.3-5.5-3.3-6.7-.1-.2-.3-.3-.4-.5-.1-.1-.2-.2-.3-.4-1.4-1.8-5.7-7.1-2.2-12.9.1-.2 3-4.3 4.8-8.7.8-1.5 1.3-3.2 1.3-5h-1.7c0 1.5-.4 3-1.1 4.3v.1c-1.5 2.8-4.5 4.7-8 4.7-3 0-5.8-1.5-7.5-4l-1.4.9c2 2.9 5.3 4.7 8.9 4.7 2.1 0 4-.6 5.7-1.6-1.2 2.2-2.3 3.8-2.4 3.8-2.7 4.5-1.9 9.5 2.3 14.8.1.1.2.2.3.3.1.2.3.3.4.5.9 1.2 2 2.5 3 6.2 1.9 6.9.3 15 .3 15l1.6.3c0-.3 1.7-8.5-.3-15.8z"></path><path d="m29.7 40.1-6.3 4.4-6.3-4.4-.9 1.3 6.4 4.5v3.9h1.6v-3.9l6.4-4.5z"></path></g></svg>
  ),
  Silhouette: (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="#97afbc" strokeWidth="8" height="60px" width="56.8px" viewBox="0 0 301.166 301.166"><g><path d="M247,228.314l-2.094-11.628c-0.589-3.272-3.704-5.455-6.981-4.895c-18.354,3.138-50.52,5.22-87.233,5.22c-37.182,0-69.702-2.137-87.947-5.337c-1.619-0.284-3.284,0.103-4.613,1.071c-1.329,0.968-2.21,2.434-2.436,4.062l-1.568,11.306c-0.227,1.639,0.226,3.299,1.254,4.596c1.028,1.296,2.542,2.114,4.19,2.267c14.75,1.37,32.414,9.186,48.27,22.648c14.167,11.996,24.168,26.135,28.837,39.222c0.924,2.589,3.377,4.32,6.125,4.32h19.203c2.748,0,5.198-1.727,6.124-4.315c4.681-13.088,14.681-27.229,28.834-39.227c14.715-12.469,30.954-20.101,44.989-22.25c1.615-0.247,3.062-1.137,4.012-2.466C246.915,231.579,247.29,229.922,247,228.314z"/><path d="M101.303,153.225c13.674,0,25.839-5.252,33.623-11.432c2.707-2.149,6.063-3.324,9.519-3.324h12.489c3.465,0,6.807,1.169,9.52,3.324c7.782,6.18,19.944,11.431,33.617,11.431c23.486,0,42.538-18.162,42.538-40.551c0-12.764-3.094-26.245-7.724-35.477c-11.4-22.726-20.889-47.209-27.712-71.702l-0.002-0.008c-1.111-3.99-5.248-6.323-9.237-5.212c-3.99,1.111-6.324,5.247-5.212,9.237l12.099,43.433c2.438,8.752-0.949,18.078-8.43,23.233c-14.187,9.778-28.121,24.807-34.789,38.146c-1.19,2.381-3.629,3.89-6.291,3.89h-9.242c-2.663,0-5.099-1.507-6.29-3.89c-6.67-13.34-20.609-28.371-34.801-38.149c-7.477-5.151-10.869-14.489-8.433-23.235l12.097-43.427c1.112-3.99-1.222-8.126-5.212-9.237c-3.995-1.111-8.126,1.223-9.237,5.212c-6.896,24.756-16.193,48.737-27.715,71.706c-4.631,9.231-7.723,22.714-7.723,35.48C58.755,135.063,77.808,153.225,101.303,153.225z"/></g></svg>
  ),
  massage: (
    <svg xmlns="http://www.w3.org/2000/svg" height="60px" version="1.1" id="Layer_1" viewBox="0 0 511.999 511.999" fill="none" stroke="#97afbc" strokeWidth="12"><g><circle cx="422.4" cy="316.8" r="51.2" /><circle cx="217.6" cy="144" r="51.2" /></g><g><path d="M511.505,390.084c-1.954-6.81-9.071-10.624-15.821-8.798l-83.908,23.979L339.9,357.35c-2.099-1.399-4.574-2.15-7.1-2.15H38.4c-7.074,0-12.8,5.726-12.8,12.8c0,7.074,5.726,12.8,12.8,12.8h290.517l73.574,49.05c2.125,1.417,4.599,2.15,7.1,2.15c1.178,0,2.364-0.162,3.516-0.486l89.6-25.6C509.508,403.959,513.442,396.876,511.505,390.084z"/><path d="M96.674,328.251c1.835,0.913,3.789,1.348,5.709,1.348c4.702,0,9.216-2.586,11.46-7.074l45.013-90.035l116.147,69.683c6.076,3.635,13.926,1.673,17.562-4.386c3.635-6.059,1.673-13.926-4.386-17.562l-128-76.8c-3.063-1.826-6.758-2.347-10.163-1.314c-3.422,0.998-6.272,3.379-7.876,6.562l-51.2,102.4C87.782,317.397,90.351,325.085,96.674,328.251z"/><path d="M332.8,406.399h-320c-7.074,0-12.8,5.726-12.8,12.8s5.726,12.8,12.8,12.8h320c7.074,0,12.8-5.726,12.8-12.8S339.874,406.399,332.8,406.399z"/></g></svg>
  ),
  products: (
    <svg xmlns="http://www.w3.org/2000/svg" height="50" fill="#97afbc" version="1.1" id="Layer_1" viewBox="0 0 512 512"><g><g><path d="M454.755,184.889H56.714C25.295,184.889,0,210.778,0,242.141v142.241c0,31.364,25.295,56.507,56.714,56.507h398.04    c31.419,0,57.245-25.143,57.245-56.507V242.141C512,210.778,486.174,184.889,454.755,184.889z M493.037,384.382    c0,20.907-17.319,37.544-38.282,37.544H56.714c-20.962,0-37.751-16.637-37.751-37.544V242.141    c0-20.907,16.789-38.289,37.751-38.289h398.04c20.963,0,38.282,17.382,38.282,38.289V384.382z" /></g></g><g><g><path d="M436.148,251.259H75.852c-5.236,0-9.482,4.245-9.482,9.481v104.296c0,5.236,4.245,9.481,9.482,9.481h360.296    c5.236,0,9.482-4.245,9.482-9.481V260.741C445.63,255.505,441.384,251.259,436.148,251.259z M426.667,355.556H85.333v-85.333    h341.333V355.556z" /></g></g><g><g><path d="M501.97,154.426l-9.759-39.178c-6.168-24.671-30.917-44.137-56.345-44.137H75.603c-25.428,0-50.177,19.514-56.345,44.185    L9.5,154.426c-0.708,2.831-0.072,5.692,1.725,7.993c1.797,2.301,4.553,3.507,7.473,3.507h474.074c2.92,0,5.677-1.157,7.473-3.458    C502.042,160.167,502.678,157.257,501.97,154.426z M30.841,146.963l6.813-27.257c4.016-16.063,21.394-29.632,37.949-29.632    h360.263c16.554,0,33.933,13.569,37.949,29.632l6.814,27.257H30.841z" /></g></g></svg>
  ),
};

const scrollToService = (id: string, closeDropdown?: () => void) => {
  const el = document.getElementById(id);
  if (el) {
    const elementPosition = el.offsetTop;
    const offset = 250;
    window.scrollTo({
      top: elementPosition - offset,
      behavior: "smooth"
    });
    if (closeDropdown) closeDropdown();
  }
};

const Category = forwardRef<HTMLDivElement>((props, ref) => {
  const [openCategory, setOpenCategory] = useState<string | null>(null);
  const dropdownRefs = useRef<{ [key: string]: HTMLDivElement | null }>({});

  const handleCategoryClick = (category: string) => {
    if (openCategory === category) {
      setOpenCategory(null);
    } else {
      setOpenCategory(category);
      // Scroll la dropdown după ce se deschide
      setTimeout(() => {
        const ref = dropdownRefs.current[category];
        if (ref) {
          // Calculează poziția pentru a include întreaga listă în ecran
          const rect = ref.getBoundingClientRect();
          
          // Scroll pentru a poziționa dropdown-ul în partea de sus a ecranului
          // cu suficient spațiu pentru întreaga listă
          const scrollTop = window.pageYOffset + rect.top + 150; // 100px margin de sus
          
          window.scrollTo({
            top: scrollTop,
            behavior: "smooth"
          });
        }
      }, 300); // Delay mai mare pentru a permite completarea animației dropdown-ului
    }
  };

  const handleTreatmentClick = (treatId: string) => {
    setOpenCategory(null);
    scrollToService(treatId);
  };

  return (
    <div className="requirements-container" ref={ref}>
      <div className="requirements-text">
        <h2>
        Bienvenue au centre d'esthétique préféré par des milliers de femmes !
        </h2>
      </div>
      <div className="requirements-items">
        {categoryTreatments.map((cat) => (
          <Disclosure key={cat.category} defaultOpen={false}>
            {({ open, close }: { open: boolean; close: () => void }) => {
              // Force the disclosure to be open only if it matches the openCategory
              const isOpen = openCategory === cat.category;
              
              // If this disclosure should be closed but is open, close it
              if (!isOpen && open) {
                setTimeout(() => close(), 0);
              }
              
              // If this disclosure should be open but is closed, open it
              if (isOpen && !open) {
                setTimeout(() => {
                  const button = document.querySelector(`[data-category="${cat.category}"]`) as HTMLElement;
                  if (button) button.click();
                }, 0);
              }
              
              return (
                <div
                  className="requirement-item-wrapper"
                  ref={el => (dropdownRefs.current[cat.category] = el)}
                >
                  <Disclosure.Button 
                    className="requirement-item" 
                    as="div"
                    data-category={cat.category}
                    onClick={() => handleCategoryClick(cat.category)}
                  >
                    <div className="requirement-icon">{icons[cat.category]}</div>
                    <div className="requirement-content">
                      <h3>{cat.label}</h3>
                      <p>{cat.description}</p>
                      <span className="arrow">{isOpen ? "↑" : "↓" }</span>
                    </div>
                  </Disclosure.Button>
                  <Disclosure.Panel static>
                    <ul className={`dropdown-treatments${isOpen ? ' open' : ''}`}>
                      {cat.treatments.map((treat) => (
                        <li key={treat.id}>
                          <button
                            className="dropdown-link"
                            tabIndex={0}
                            onClick={() => handleTreatmentClick(treat.id)}
                          >
                            <span className="dropdown-link-inner">
                              <span className="dropdown-link-title">
                                {treat.title}
                              </span>
                              {/* {"label" in treat && treat.label && (
                                <span className="treatment-label">
                                  {treat.label}
                                </span>
                              )} */}
                            </span>
                          </button>
                        </li>
                      ))}
                    </ul>
                  </Disclosure.Panel>
                </div>
              );
            }}
          </Disclosure>
        ))}
      </div>
    </div>
  );
});

export default Category;
